import React from "react";
import { Tooltip } from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PauseIcon from "@mui/icons-material/Pause";
import { IMPACT_LOWERCASE, PAUSE, PLAY, WEATHER_LOWERCASE } from "../../UserVisibleStrings";
import { Button, Container } from "./PlayButtonStyle";
import { setIsPlaying } from "../../../features/time/playbackSlice";
import { MapStyle, useMapStyle } from "../../../features/mapDisplay/mapDisplaySlice";
import { useDispatch } from "react-redux";
import { RouteViewState, useRouteViewState } from "../../../features/riskViewer/riskViewerSlice";

interface PlayButtonProps
{
    isPlaying: boolean;
    isMobile: boolean;
}

/**
 * PlayButton component for toggling play/pause state.
 *
 * @param {PlayButtonProps} props - The props for the PlayButton element
 * @returns {JSX.Element} The PlayButton component
 */
const PlayButton: React.FC<PlayButtonProps> = ( { isPlaying, isMobile } ) =>
{
    const mapStyle = useMapStyle();
    const dispatch = useDispatch();
    const routeViewState = useRouteViewState();
    const buttonColor = ( mapStyle === MapStyle.Satellite || mapStyle === MapStyle.Dark ) ? "rgb(25,118,210, 0.8)" : "rgba(0, 0, 0, 0.1)";
    const arrowColor = ( mapStyle === MapStyle.Satellite || mapStyle === MapStyle.Dark ) ? "rgba(255, 255, 255, 1)" : "rgba(0, 0, 0, 0.54)";

    const displayContent = ( routeViewState === RouteViewState.COLORED_ROUTE ) ? "my route" : WEATHER_LOWERCASE + " " + IMPACT_LOWERCASE;
    const tooltipText = ( isPlaying ? PAUSE : PLAY ) + " " + displayContent;
    return (
        <Tooltip title = {tooltipText}>
            <Container isMobile = {isMobile}>
                <Button
                    onClick = {() => dispatch( setIsPlaying( !isPlaying ) )}
                    style = {{ backgroundColor: buttonColor, color: arrowColor }}
                >
                    {isPlaying ? <PauseIcon/> : <PlayArrowIcon/>}
                </Button>
            </Container>
        </Tooltip>
    );
};

export default PlayButton;
